export default __webpack_public_path__ + "static/sa-c37e33b419157be300f29173c897cd01.svg";